module.exports = __webpack_public_path__ + "static/media/kidneys.e11e3b2f.svg";